export const DEFAULT_ROOF_FRAMING_SPACING: number = 24;
export const MIN_ROOF_FRAMING_SPACING: number = 6;
export const TRUSS_THICKNESS = 1.5;
export const HALF_TRUSS_THICKNESS = 0.5 * TRUSS_THICKNESS;
export const TRUSS_WIDTH_TOLERANCE = 3.5;
export const DEFAULT_WALL_FRAMING_OFFSET = 1.75;
export const TOP_CHORD_CLIP_EXTENSION = 6;
